export function getAzureRegion(regionCode) {
  let fullRegion = ''
  switch (regionCode) {
    case 'AUE':
      fullRegion = 'Azure Australia East'
      break
    case 'AUS':
      fullRegion = 'Azure Australia SouthEast'
      break
    case 'CAC':
      fullRegion = 'Azure Canada Central'
      break
    case 'CAE':
      fullRegion = 'Azure Canada East'
      break
    case 'EUS':
      fullRegion = 'Azure East US'
      break
    case 'WUS':
      fullRegion = 'Azure West US'
      break
    case 'UKS':
      fullRegion = 'Azure UK South'
      break
    case 'UKW':
      fullRegion = 'Azure UK West'
      break
    case 'UAN':
      fullRegion = 'Azure UAE North'
      break
    case 'UAC':
      fullRegion = 'Azure UAE Central'
      break
    case 'WEU':
      fullRegion = 'Azure West Europe'
      break
    case 'NEU':
      fullRegion = 'Azure North Europe'
      break
    case 'USG':
      fullRegion = 'Azure Gov US Virginia'
      break
    default:
      fullRegion = 'Unknown'
  }
  return fullRegion
}